


































































































































































































































































































































import BaseCard from '../../_components/BaseCard.vue';
import BaseComponent from '@/core/base.component';
import { Prop, Vue, Component } from 'vue-property-decorator';
import {
  DeliverySpaceDto,
  DeliverySpaceListDto,
  CompanyDto,
} from '../../../dto';
import { CONST_YN, Pagination, YN } from '@/common';

import CompanyService from '../../../services/company.service';
import DeliverSpaceService from '../../../services/delivery-space.service';

import DeliverySpaceCreate from './DeliverySpaceCreate.vue';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';

import toast from '../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'DeliverySpaceList',
  components: {
    DeliverySpaceCreate,
  },
})
export default class DeliverySpaceList extends BaseComponent {
  private deliverySpaceList: DeliverySpaceDto[] = [];
  private deliverySpaceSearchDto = new DeliverySpaceListDto();
  private deliverySpaceDto = new DeliverySpaceDto();
  private deliverySpaceTotalCount = 0;
  private pagination = new Pagination();
  private companySelect: CompanyDto[] = [];
  private dataLoading = false;
  private ynSelect: YN[] = [...CONST_YN];

  // 업체 셀렉트 박스
  getCompanies() {
    CompanyService.findForSelect().subscribe(res => {
      this.companySelect = res.data;
    });
  }

  // 타입 공간 리스트
  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1; // 최초 페이지 진입시 페이지 초기화
    } else {
      if (isSearch) this.pagination.page = 1; // 검색버튼 클릭시 페이지 초기화
      RouterQueryParamMapper(this.deliverySpaceSearchDto, this.pagination);
    }
    DeliverSpaceService.findAll(
      this.deliverySpaceSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.deliverySpaceList = res.data.items;
        this.deliverySpaceTotalCount = res.data.totalCount;
      }
    });
  }

  paginateSearch() {
    this.findAll(true);
  }

  search() {
    this.findAll(true, true);
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.deliverySpaceSearchDto = new DeliverySpaceListDto();
      this.findAll();
    }
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.deliverySpaceSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getCompanies();
  }

  mounted() {
    // create delivery space
    this.$root.$on('delivery_space_create', () => {
      this.clearOut();
    });
  }
}
